//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { Formik } from "formik";
import Select from "react-select";
import { Card, Col, Container, Form, Row, Button } from "react-bootstrap";
import { SystemMessageActions } from './messageAction';
import moment from 'moment-timezone';
import { useLocation, useNavigate } from 'react-router-dom';
import DateTime from "react-datetime";
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";
import { CandidatePageActions } from "../candidatePageActions";


const MessageForm = ({ data, candidateCMSData }) => {
    const navigate = useNavigate();
    const [timezoneJson, setTimezoneJson] = useState([]);
    const [SystemMessageJson, setSystemMessageJson] = useState({});
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    const [systemMessageCMSData, setSystemMessageCMSData] = useState({});
    const [commonComponentCMSData, setCommonComponentCMSData] = useState({});
    const [systemMessageValidationMsgCMSData, setSystemMessageValidationMsgCMSData] = useState({});

    // const fetchSystemMessageJson = async () => {

    //     let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    //     await SystemMessageActions.GetSystemMessageJson().then(
    //         (res) => {
    //             if (res.status === 200 || res.status === 204) {
    //                 setSystemMessageJson(JSON.parse(JSON.stringify(res?.data)));
    //             }
    //             else {
    //                 refErrorMessageAlert.showAlert = true;
    //                 setErrorAlert(refErrorMessageAlert);
    //             }
    //         },
    //         (err) => {
    //             console.log(err);
    //         }
    //     );
    // }

    // const fetchSystemMessageLabel = (key) => {
    //     let refJsonContent = JSON.parse(JSON.stringify(SystemMessageJson));
    //     let label = "";

    //     refJsonContent?.Properties?.Labels?.map((x) => {
    //         if (x.Key === key) {
    //             label = x.Phrase;
    //         }
    //     });

    //     return label;
    // };

    const fetchSystemMessageLabel = (key) => {
        if (systemMessageCMSData && systemMessageCMSData.Labels) {
            return systemMessageCMSData.Labels.find((el) => el.Key === key)?.Phrase || '';
        }
        return '';
    }

    const fetchCommonComponentLabel = (key) => {
        if (commonComponentCMSData && commonComponentCMSData.Labels) {
            return commonComponentCMSData.Labels.find((el) => el.Key === key)?.Phrase || '';
        }
        return '';
    }

    const fetchSystemMessageValidationLabel = (key) => {
        if (systemMessageValidationMsgCMSData && systemMessageValidationMsgCMSData.Labels) {
            return systemMessageValidationMsgCMSData.Labels.find((el) => el.Key === key)?.Phrase || '';
        }
        return '';
    }


    const fetchTimezoneJson = async (language) => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        await SystemMessageActions.GetTimezoneJson(language).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    const timezoneRes = JSON.parse(JSON.stringify(res?.data[0].items));
                    const timezones = [];
                    timezoneRes?.forEach((item) => {
                        let timezone = {}
                        timezone.title = item.title;
                        timezone.id = item.id;
                        item?.standardCodes?.forEach((subItem) => {
                            if (subItem?.itemCodeStandardName === 'iana') {
                                timezone.standardCodeValue = subItem?.standardCodeValue
                                timezones.push(timezone);
                            }
                        })
                    })
                    setTimezoneJson(timezones);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const updateSelectedTimeZone = (timeZone, selectedDateTime) => {
        let localTime = moment(selectedDateTime);
        let selectedTimeZoneFormat = moment().tz(timeZone);
        selectedTimeZoneFormat.set(localTime?.toObject());
        return selectedTimeZoneFormat;
    }

    const isFutureTime = (timeZone, selectedDateTime) => {
        let currentTime = moment().tz(timeZone).format();
        let selectedTimeZone = updateSelectedTimeZone(timeZone, selectedDateTime);
        return Date.parse(currentTime) > Date.parse(selectedTimeZone)
    }

    useEffect(() => {
        //fetchSystemMessageJson();
        fetchTimezoneJson(data.languageCode);
    }, []);

    useEffect(() => {
        setSystemMessageCMSData(candidateCMSData?.pageContent["Candidates.SystemMessage"]);
        setCommonComponentCMSData(candidateCMSData?.pageContent["CommonComponent"]);
        setSystemMessageValidationMsgCMSData(candidateCMSData?.pageContent["Candidates.SystemMessageValidationText"]);
    }, [candidateCMSData]);

    const updateMessage = async (payload, resetForm, setSubmit) => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        await SystemMessageActions.UpdateSystemMessage(data.id, payload).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    resetForm();
                    setSubmit();
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const deleteMessage = async () => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        await SystemMessageActions.DeleteSystemMessage(data.id).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    const deleteMessageRes = JSON.parse(JSON.stringify(res?.data));
                    navigate(-1);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    let userId = JSON.parse(window.sessionStorage.getItem('UserAccount'))["accountId"];

    if (timezoneJson && timezoneJson.length > 0) {
        return (
            <Formik
                initialValues={{
                    country: data.countryCodes,
                    language: data.languageCode,
                    messageHeader: data.messageTitle,
                    messageContent: data.messageDescription,
                    persistent: data.isPersistent,
                    timezone: data.timezone,
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    fromDay: moment(data.fromDate)?.tz(data?.timezone)?.format('DD/MM/YYYY'),
                    fromTime: moment(data.fromDate)?.tz(data?.timezone)?.format('hh:mm A'),
                    toDay: moment(data.toDate)?.tz(data?.timezone)?.format('DD/MM/YYYY'),
                    toTime: moment(data.toDate)?.tz(data?.timezone)?.format('hh:mm A'),
                    validDate: false,
                }}
                validationSchema={Yup.object().shape({
                    messageHeader: Yup.string()
                        .max(60)
                        .required(fetchSystemMessageValidationLabel('SystemMessage.headerValidationMessage')),
                    messageContent: Yup.string().max(700).required(fetchSystemMessageValidationLabel('SystemMessage.contentValidationMessage')),
                })}
                onReset={(values, { resetForm }) => {
                    navigate(-1);
                }}
                onSubmit={(values, { resetForm, setSubmitting }) => {
                    const data = {
                        messageTitle: values.messageHeader,
                        messageDescription: values.messageContent,
                        sentBy: userId,
                        fromDate: updateSelectedTimeZone(values.timezone, values.fromDate)?.utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                        toDate: updateSelectedTimeZone(values.timezone, values.toDate)?.utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                        isPersistent: values.persistent,
                        timezone: values.timezone
                    }
                    updateMessage(data, resetForm, setSubmitting);
                }
                }
            >
                {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    handleReset,
                    isSubmitting,
                    touched,
                    values,
                    setFieldValue,
                }) => (
                    <Form onSubmit={handleSubmit} onReset={handleReset}>
                        {errorAlert?.showAlert &&
                            <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                        }
                        <Form.Group className="mb-3">
                            <Row>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.Edit.CountryLabel')}</Col>
                                <Col lg="4">{data.countryCodes}</Col>
                            </Row>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Row>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.Edit.LanguageLabel')}</Col>
                                <Col lg="4">{data.languageCode}</Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Row className='mt-3'>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.messageHeaderLabel')}</Col>
                                <Col lg="4">
                                    <Form.Control type="text" name="messageHeader" maxLength={60}
                                        placeholder={fetchSystemMessageLabel('SystemMessage.PlaceHolder.MessageHeader')}
                                        value={values.messageHeader}
                                        isInvalid={Boolean(touched.messageHeader && errors.messageHeader)}
                                        onBlur={handleBlur}
                                        onChange={handleChange} />
                                    {!!touched.messageHeader && (
                                        <Form.Control.Feedback type="invalid">
                                            {errors.messageHeader}
                                        </Form.Control.Feedback>
                                    )}
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Row className='mt-3'>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.messageContentLabel')}</Col>
                                <Col lg="4">
                                    <Form.Control as="textarea" name="messageContent" maxLength={700}
                                        placeholder={fetchSystemMessageLabel('SystemMessage.PlaceHolder.MessageContent')}
                                        value={values.messageContent}
                                        isInvalid={Boolean(touched.messageContent && errors.messageContent)}
                                        onBlur={handleBlur}
                                        onChange={handleChange} />
                                    {!!touched.messageContent && (
                                        <Form.Control.Feedback type="invalid">
                                            {errors.messageContent}
                                        </Form.Control.Feedback>
                                    )}
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Row className='mt-3'>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.persistentLabel')}</Col>
                                <Col lg="4">
                                    <Form.Check
                                        name='persistent'
                                        checked={values.persistent}
                                        type="checkbox"
                                        onChange={(data) => {
                                            setFieldValue("persistent", data.target.checked);
                                        }}
                                        aria-label="persistent check"
                                    />
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Row className='mt-3'>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.timezoneLabel')}</Col>
                                <Col lg="6">
                                    <Form.Select name="timeZone" value={values.timezone} aria-label="TimeZone Select"
                                        onChange={e => {
                                            setFieldValue("timezone", e.target.value);
                                        }}>
                                        <option value=''>{fetchSystemMessageLabel('SystemMessage.timezoneOption')}</option>
                                        {timezoneJson.map((item) => (
                                            <option key={item?.standardCodeValue} value={item?.standardCodeValue}>
                                                {item?.title}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Row className='mt-3'>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.fromDateLabel')}</Col>
                                <Col lg="2">
                                    <DateTime
                                        dateFormat="DD/MM/YYYY"
                                        value={values.fromDay}
                                        onChange={(data) => {
                                            setFieldValue("fromDay", moment(data).format('DD/MM/YYYY'));
                                            setFieldValue("fromDate", moment(moment(data).format('DD/MM/YYYY') + ' ' +
                                                moment(values.toTime).format("HH:mm"), 'DD/MM/YYYY HH:mm:ss').format());
                                        }}
                                        closeOnSelect={true}
                                        timeFormat={false}
                                        isValidDate={current => current.isAfter(moment().subtract(1, 'day'))}
                                    />
                                </Col>
                                <Col lg="2">
                                    <DateTime
                                        dateFormat={false}
                                        timeFormat={true}
                                        viewMode="time"
                                        closeOnSelect={true}
                                        value={values.fromTime}
                                        onChange={(data) => {
                                            setFieldValue("fromTime", data);
                                            setFieldValue("fromDate",
                                                moment(values.fromDay + ' ' +
                                                    moment(data, ["h:mm A"]).format("HH:mm"), 'DD/MM/YYYY HH:mm:ss').format());
                                        }}
                                    />
                                </Col>
                                <Col lg="4">
                                    {values.fromDate && isFutureTime(values.timezone, values.fromDate) &&

                                        <div class="invalid-feedback" style={{ display: "block" }}> {fetchSystemMessageValidationLabel('SystemMessage.fromDateValidationError')}</div>}
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Row className='mt-3'>
                                <Col lg="2">{fetchSystemMessageLabel('SystemMessage.toDateLabel')}</Col>
                                <Col lg="2">
                                    <DateTime
                                        dateFormat="DD/MM/YYYY"
                                        value={values.toDay}
                                        onChange={(data) => {
                                            setFieldValue("toDay", moment(data).format('DD/MM/YYYY'));
                                            setFieldValue("toDate",
                                                moment(moment(data).format('DD/MM/YYYY') + ' ' +
                                                    moment(values.toTime).format("HH:mm"), 'DD/MM/YYYY HH:mm:ss').format())
                                        }}
                                        closeOnSelect={true}
                                        timeFormat={false}
                                        isValidDate={current => current.isAfter(moment().subtract(1, 'day'))}
                                    />
                                </Col>
                                <Col lg="2">
                                    <DateTime
                                        dateFormat={false}
                                        timeFormat={true}
                                        viewMode="time"
                                        closeOnSelect={true}
                                        value={values.toTime}
                                        onChange={(data) => {
                                            setFieldValue("toTime", data);
                                            setFieldValue("toDate",
                                                moment(values.toDay + ' ' + moment(data, ["h:mm A"]).format("HH:mm"), 'DD/MM/YYYY HH:mm:ss').format())
                                        }}
                                    />
                                </Col>
                                <Col lg="4">
                                    {((values.toDate && isFutureTime(values.timezone, values.toDate)) || (Date.parse(values?.fromDate) > Date.parse(values?.toDate))) &&
                                        <div class="invalid-feedback" style={{ display: "block" }}>{fetchSystemMessageValidationLabel('SystemMessage.toDateValidationError')}</div>}
                                </Col>
                            </Row>
                        </Form.Group>

                        <Row className="mt-5">
                            <Col lg="2" className='text-center'>
                                <Button
                                    type="reset"
                                    variant="primary"
                                    size="lg"
                                >
                                    {fetchCommonComponentLabel('Common.Cancel')}
                                </Button>
                            </Col>
                            <Col lg="2" className='text-center'>
                                <Button
                                    type="button"
                                    variant="primary"
                                    size="lg"
                                    onClick={deleteMessage}
                                >
                                    {fetchCommonComponentLabel('Common.Delete')}
                                </Button>
                            </Col>
                            <Col lg="2" className='text-center'>
                                <Button
                                    type="submit"
                                    variant="primary"
                                    size="lg"
                                    disabled={(isSubmitting && values.validDate) ||
                                        !values.fromDate || !values.toDate ||
                                        isFutureTime(values.timezone, values.toDate) ||
                                        isFutureTime(values.timezone, values.fromDate) ||
                                        (Date.parse(values.fromDate) > Date.parse(values.toDate))}
                                >
                                    {fetchCommonComponentLabel('Common.Save')}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        )
    } else {
        return (<></>)
    }
}

const EditSystemMessage = () => {
    const [adminCandidateCMS, setAdminCandidateSearchCMS] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {} });
    const [systemMessageCms, setSystemMessageCms] = useState();
    const location = useLocation();
    const data = location.state;

    const getAdminCandidateSearchCMSContent = async () => {
        const payload = { pagename: 'Candidates' }
        await CandidatePageActions.getAdminCandidateCMSContent(payload).then((res) => {
            if (res.status == 200 || res.status == 204) {
                const data = res.data;
                data.Pages.forEach((el) => {
                    if (el.Key === 'Candidates.CandidatesSearch') {
                        const { Title, Description, TabNavigationTitle, Components } = el;
                        setAdminCandidateSearchCMS({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
                        setSystemMessageCms(Components['Candidates.SystemMessage']);
                    }
                });
            }
        });
    }

    const fetchSystemMessageLabel = (key) => {
        if (systemMessageCms && systemMessageCms.Labels) {
            return systemMessageCms.Labels.find((el) => el.Key === key)?.Phrase || '';
        }
        return '';
    }

    useEffect(() => {
        getAdminCandidateSearchCMSContent();
    }, []);

    return (
        <React.Fragment>
            <Helmet title="Edit System Message" />
            <Container fluid className="p-0">
                <h1 className="h3 mb-3">{fetchSystemMessageLabel('SystemMessage.editSystemMessage')}</h1>
                <Card>
                    <Card.Body>
                        <MessageForm data={data} candidateCMSData={adminCandidateCMS} />
                    </Card.Body>
                </Card>
            </Container>
        </React.Fragment>
    )
}


export default EditSystemMessage;
